import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  BUILD_EMPLOYMENT,
  EMPLOYMENT_CHANGED,
  UPDATE_EMPLOYMENTS_FAILURE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_EMPLOYMENTS_SUCCESS,
  LOAN_APPLICATION_USER_VERIFY_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
} from './../../actions/types'

const allIds = (state = [], {type, payload}) => {
  let isPrimary = true;
  let employment, secondaryEmployment = null;
  let flowState = 'employment'
  if (payload && payload.employment) {
    flowState = payload.loanApplicationUser.flowState
    employment = Object.keys(payload.employment)
    secondaryEmployment = Object.keys(payload.secondaryEmployment)
  }

  if (payload && payload.applicationFlow && payload.applicationFlow.employment) {
    flowState = payload.applicationFlow.loanApplicationUser.flowState
    employment = Object.keys(payload.applicationFlow.employment)
    secondaryEmployment = Object.keys(payload.applicationFlow.secondaryEmployment)
  }

  isPrimary = flowState === 'employment'

  switch (type) {
    case UPDATE_EMPLOYMENTS_SUCCESS:
    case LOAN_APPLICATION_FETCH_SUCCESS:
      if (employment || secondaryEmployment) {
        return isPrimary ? employment : secondaryEmployment
      }
      return []
    case BUILD_EMPLOYMENT:
      return [...new Set([...state, payload.key])]
    case UPDATE_EMPLOYMENTS_FAILURE:
      return payload.result || []

    case UPDATE_PROFILE_SUCCESS:
    case LOAN_APPLICATION_USER_VERIFY_SUCCESS:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      if (payload.employment !== undefined) {
        return isPrimary ? employment : secondaryEmployment
      }

      return state
    case EMPLOYMENT_CHANGED:
      if (payload._destroy === 1) {
        return state.filter(id => id.toString() !== payload.key.toString())
      }

      return state;

    default:
      return state;
  }
}

export default allIds;
